<template>
  <Modal name="promocode" @closeModal="closeModal" size="lg" title="Подарок за&nbsp;репост">
    <template v-slot:content>
      <div class="promocode">
        <img class="promocode__img" src="../../assets/images/coffee-2.png" alt="">
        <div class="promocode__code">{{ code }}</div>
        <div class="promocode__text">
          <span>Как активировать промокод:</span>
          <ul>
            <li>Пройти по ссылке <a href="https://www.ozon.ru/my/codes" class="_undeline-link" target="_blank">https://www.ozon.ru/my/codes</a></li>
            <li>Ввести промокод из&nbsp;письма и&nbsp;активировать его</li>
            <li>Найти нужный товар по&nbsp;артикулу 686577014 или&nbsp;по&nbsp;<a href="https://www.ozon.ru/product/kofe-molotyy-poetti-leggenda-original-naturalnyy-zharenyy-250-g-686577014/?asb=qyKSaT6SEmz2WuWRq1mkFkxnuFjOxSqY6a40BVfRTIc%253D&asb2=XGs-Etn2yZShR4UwELWtJ1mqEKkMb8zqk8CUIoQSciyxSUk6nO8QKYNxiatMizoU56cBIpKUjHqlB3l_RGa43A&avtc=1&avte=1&avts=1669821777&keywords=686577014&sh=WmIpSmT2kg" class="_undeline-link" target="_blank">ссылке</a></li>
            <li>Положить товар в&nbsp;корзину и&nbsp;перейти к&nbsp;оформлению заказа</li>
            <li>Выбрать способ получения</li>
            <li>Оформить заказ</li>
          </ul>
        </div>
        <a
          href="https://www.ozon.ru/my/codes"
          target="_blank"
          class="btn btn--primary w-100"
        >
          Активировать промокод
        </a>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from "@/components/Modal.vue";

export default {
  components: {
    Modal,
  },
  data: function () {
    return {
      code: null,
    };
  },
  methods: {
    closeModal(name) {
      this.$modal.hide(name);
    },
    beforeOpen(event) {
      this.code = event.params.code;
    },
  },
};
</script>
<style lang="scss" scoped>
.promocode {
  display: flex;
  flex-direction: column;
  align-items: center;
  &__img {
    display: block;
    width: rem(340px);
    margin: 0 auto rem(30px);
  }
  &__code {
    margin-bottom: rem(20px);
    padding: rem(18px) rem(21px) rem(13px);
    background: rgba(#FDEECD, .36);
    font-size: rem(48px);
    font-family: Arial, sans-serif;
    line-height: 1;
  }
  &__text {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 90%;
    font-size: rem(24px);
    span {
      display: inline-block;
      margin: 0 auto rem(15px);
      text-align: center;
      font-size: rem(32px);
      border-bottom: 2px solid currentColor;
    }
    ul {
      width: 100%;
      margin-bottom: rem(40px);
      list-style: disc;
    }
  }
  @media (max-width: $sm) {
    .btn {
      font-size: rem(14px);
      line-height: rem(50px);
    }
    &__text {
      font-size: rem(16px);
      span {
        font-size: rem(18px);
      }
    }
    &__code {
      font-size: rem(36px);
    }
  }
}
</style>